module.exports = ".mat-form-field-prefix{\n   width: 50px !important;\n }\n\n"